import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomesComponent } from './homes/homes.component';
import { RouterModule, Routes } from '@angular/router';
import { HomeDetailComponent } from './home-detail/home-detail.component';
import { FormsModule } from '@angular/forms';

const routes: Routes = [
  { path: '', component: HomesComponent },
  { path: 'detail', component: HomeDetailComponent },
]

@NgModule({
  declarations: [HomesComponent, HomeDetailComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
  ]
})
export class HomesModule { }
